import { css } from 'lit';

export const featuresPageStyles = css`
  .feature-page {
    padding: 6rem 2rem 4rem;
    background: var(--sl-color-neutral-50, #f8fafc);
    min-height: 100vh;
  }

  .feature-page-hero {
    max-width: 960px;
    margin: 0 auto 3rem;
    text-align: center;
    display: grid;
    gap: 1.25rem;
  }

  .feature-page-hero h1 {
    font-size: 3rem;
    line-height: 1.1;
    color: var(--sl-color-neutral-900);
  }

  .feature-page-hero p {
    font-size: 1.15rem;
    color: var(--sl-color-neutral-600);
    max-width: 720px;
    margin: 0 auto;
  }

  .feature-page-hero-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  .feature-page-grid {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    gap: 2.5rem;
  }

  .feature-module {
    background: white;
    border-radius: 20px;
    border: 1px solid var(--sl-color-neutral-200);
    box-shadow: var(--sl-shadow-large, 0 30px 60px -20px rgba(15, 23, 42, 0.35));
    padding: 2rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    align-items: flex-start;
  }

  .feature-module:nth-child(odd) {
    background: linear-gradient(135deg, #ffffff 0%, #eef2ff 100%);
  }

  .feature-module-content {
    flex: 1 1 380px;
    display: grid;
    gap: 1.25rem;
  }

  .feature-module-content h2 {
    font-size: 2rem;
    color: var(--sl-color-neutral-900);
    margin: 0;
  }

  .feature-module-group {
    display: grid;
    gap: 0.5rem;
  }

  .feature-module-group h3 {
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--sl-color-neutral-800);
    margin: 0;
  }

  .feature-module-group ul {
    margin: 0;
    padding-left: 1.2rem;
    display: grid;
    gap: 0.35rem;
    color: var(--sl-color-neutral-600);
  }

  .feature-module-preview {
    flex: 1 1 320px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .feature-module .feature-panel-meta {
    margin-top: 0.5rem;
  }

  .feature-page-cta {
    max-width: 960px;
    margin: 4rem auto 0;
    background: linear-gradient(135deg, var(--sl-color-primary-600), var(--sl-color-primary-700));
    color: white;
    padding: 3rem;
    border-radius: 20px;
    text-align: center;
    display: grid;
    gap: 1rem;
  }

  .feature-page-cta p {
    font-size: 1.1rem;
    margin: 0 auto;
    max-width: 640px;
    color: rgba(255, 255, 255, 0.85);
  }

  .feature-page-cta-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    .feature-page {
      padding: 5.5rem 1.25rem 3rem;
    }

    .feature-page-hero h1 {
      font-size: 2.25rem;
    }

    .feature-module {
      padding: 1.5rem;
    }

    .feature-page-cta {
      padding: 2.5rem 1.75rem;
    }
  }
`;
